import { TravelerFeature } from '../features/travelers/traveler.feature';
import { StandardLayerRenderer } from './standard-layer.renderer';

export class TravelerLayerRenderer extends StandardLayerRenderer {
  protected Feature = TravelerFeature;
}
